// extracted by mini-css-extract-plugin
export default {"slide":"yeG56"};